// default
export const Safety = 'safety';
export const SAFETY_SLICE_NAME = `${Safety}Slice`;

// action
export const GET_SAFETIES = `${Safety}/getSafetyList`;
export const GET_SAFETY_DETAIL = `${Safety}/getSafetyDetail`;
export const DELETE_SAFETY = `${Safety}/deleteSafetyEdu`;
export const CREATE_SAFETY = `${Safety}/createSafety`;
export const UPDATE_SAFETY = `${Safety}/updateSafety`;
export const UPDATE_SAFETY_STATUS = `${Safety}/updateSafetyStatus`;
export const DELETE_SAFETY_ATTENDANCE = `${Safety}/deleteSafetyAttendance`;
export const DELETE_ALL_SAFETY_ATTENDANCE = `${Safety}/deleteALLSafetyAttendance`;
export const CREATE_SAFETY_BY_MANUAL = `${Safety}/createSafetyByManual`;
export const CREATE_SAFETY_BY_NFC = `${Safety}/createSafetyByNfc`;

export const GET_SAFETY_SETTING = `${Safety}/getSafetySetting`;
export const CREATE_SAFETY_SETTING = `${Safety}/createSafetySetting`;
export const UPDATE_SAFETY_SETTING = `${Safety}/updateSafetySetting`;
export const DELETE_SAFETY_SETTING = `${Safety}/deleteSafetySetting`;

// actions
export const actions = {
  GET_SAFETIES,
  GET_SAFETY_DETAIL,
  DELETE_SAFETY,
  CREATE_SAFETY,
  UPDATE_SAFETY,
  UPDATE_SAFETY_STATUS,
  DELETE_SAFETY_ATTENDANCE,
  DELETE_ALL_SAFETY_ATTENDANCE,
  CREATE_SAFETY_BY_MANUAL,
  CREATE_SAFETY_BY_NFC,
  GET_SAFETY_SETTING,
  CREATE_SAFETY_SETTING,
  UPDATE_SAFETY_SETTING,
  DELETE_SAFETY_SETTING
};
